"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutButtonPropsInterface = exports.CheckoutPropsInterface = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var CheckoutPropsInterface = {
  termId: _propTypes.default.number,
  currencyCode: _propTypes.default.string,
  itemConfigurations: _propTypes.default.arrayOf(_propTypes.default.shape({
    merchandiseId: _propTypes.default.number.isRequired,
    quantity: _propTypes.default.number.isRequired
  })),
  productBasedOffers: _propTypes.default.array,
  additionalUnitQuantity: _propTypes.default.number
};
exports.CheckoutPropsInterface = CheckoutPropsInterface;
var CheckoutButtonPropsInterface = (0, _extends2.default)({}, CheckoutPropsInterface, {
  onClick: _propTypes.default.func,
  onError: _propTypes.default.func,
  beforeRedirect: _propTypes.default.func
});
exports.CheckoutButtonPropsInterface = CheckoutButtonPropsInterface;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/checkout/CheckoutPropsInterface.js
// module id = 466
// module chunks = 5 6